module.exports = __webpack_public_path__ + "img/follow-up.2535e835.png";